import React, { memo } from "react";
import { StyledTooltip } from "./styles";

const Tooltip = ({
  children,
  color = "#ffffff",
  title,
  border = 2,
  maxWidth,
  minHeight = 32,
  mouseLeaveDelay = 0.1,
  ...rest
}) => (
  <StyledTooltip
    color={color}
    title={title}
    overlayStyle={{
      borderRadius: `${border}px`,
      maxWidth: `${maxWidth}px`,
      minHeight: `${minHeight}px`,
    }}
    overlayInnerStyle={{
      borderRadius: `${border}px`,
      maxWidth: `${maxWidth}px`,
      minHeight: `${minHeight}px`,
    }}
    mouseLeaveDelay={mouseLeaveDelay}
    {...rest}
  >
    {children}
  </StyledTooltip>
);

export default memo(Tooltip);
